import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight, Plus } from 'lucide-react';
import { listCategories, createCategory } from '../api';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { useToast } from '../hooks/use-toast';

export default function Checklist() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [cats, setCats] = useState([]);
  const [showAdd, setShowAdd] = useState(false);
  const [name, setName] = useState('');

  const load = () => listCategories().then(setCats).catch(() => {});
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!name.trim()) return;
    try { await createCategory({ name, icon: '📋' }); setName(''); setShowAdd(false); load(); toast({ title: 'Kategori ditambahkan' }); }
    catch (e) { toast({ title: 'Gagal menambahkan', variant: 'destructive' }); }
  };

  const totalTasks = cats.reduce((a,c) => a + (c.total||0), 0);
  const doneTasks = cats.reduce((a,c) => a + (c.done||0), 0);
  const percent = totalTasks ? Math.round((doneTasks/totalTasks)*100) : 0;

  return (
    <div className="px-5 pt-8 lg:pt-10">
      <div className="mb-6 flex items-start justify-between">
        <div>
          <h1 className="font-serif text-4xl text-sage-700">Checklist</h1>
          <p className="text-sage-500 text-sm mt-1">{doneTasks} dari {totalTasks} tugas selesai</p>
        </div>
      </div>

      <div className="bg-white rounded-2xl p-5 border border-cream-200 mb-6">
        <div className="flex items-center justify-between mb-2">
          <div className="text-sage-700 font-medium">Progress Keseluruhan</div>
          <div className="text-terracotta-500 font-serif text-xl">{percent}%</div>
        </div>
        <div className="h-2.5 bg-cream-100 rounded-full overflow-hidden">
          <div className="h-full bg-terracotta-500 transition-all" style={{width: `${percent}%`}} />
        </div>
      </div>

      {showAdd ? (
        <div className="bg-white rounded-2xl p-4 border border-terracotta-200 mb-4 flex gap-2">
          <Input autoFocus value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && add()} placeholder="Nama kategori baru" className="h-10 bg-cream-50 border-cream-200 rounded-xl" />
          <Button onClick={add} className="bg-terracotta-500 hover:bg-terracotta-600 text-white rounded-xl h-10">Tambah</Button>
          <Button variant="ghost" onClick={() => { setShowAdd(false); setName(''); }} className="text-sage-500 h-10">Batal</Button>
        </div>
      ) : (
        <button onClick={() => setShowAdd(true)} className="w-full bg-terracotta-100/50 hover:bg-terracotta-100 border border-terracotta-100 rounded-2xl py-3 text-terracotta-600 font-medium mb-4 flex items-center justify-center gap-2 transition-colors">
          <Plus className="w-5 h-5" /> Tambah kategori
        </button>
      )}

      <div className="grid md:grid-cols-2 gap-3">
        {cats.map(c => {
          const p = c.total ? Math.round((c.done/c.total)*100) : 0;
          return (
            <button key={c.id} onClick={() => navigate(`/app/checklist/${c.id}`)} className="bg-white rounded-2xl p-5 border border-cream-200 hover:border-terracotta-200 hover:shadow-md transition-all text-left">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-xl bg-cream-100 flex items-center justify-center text-2xl">{c.icon}</div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-sage-700">{c.name}</div>
                  <div className="text-xs text-sage-500 mt-0.5">{c.done}/{c.total} tugas selesai</div>
                  <div className="mt-2 h-1.5 bg-cream-100 rounded-full overflow-hidden">
                    <div className="h-full bg-terracotta-500" style={{width: `${p}%`}} />
                  </div>
                </div>
                <ChevronRight className="w-5 h-5 text-sage-400" />
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
